module.exports = __webpack_public_path__ + "img/no-transaction.3b3a20a3.svg";